import { ReactElement } from "react";
import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  Path,
} from "react-hook-form";

import { ErrorMessage } from "../catalyst/ErrorMessage";
import { Field } from "../catalyst/Field";
import { Label } from "../catalyst/Label";
import RadioButtonGroup from "./RadioButtonGroup";

type Props<FormType extends FieldValues> = {
  control: Control<FormType>;
  errors: FieldErrors<FormType>;
  fieldName: Path<FormType>;
  label: string;
  optionList: string[];
};

const ControlledRadioButtonGroup = <FormType extends FieldValues>({
  control,
  errors,
  fieldName,
  label,
  optionList,
}: Props<FormType>): ReactElement => {
  const errorMessage = errors[fieldName]?.message as string | undefined;

  return (
    <Field>
      <Label>{label}</Label>
      <Controller
        control={control}
        name={fieldName}
        render={({ field: { onChange, value } }) => (
          <RadioButtonGroup
            onChange={onChange}
            optionList={optionList}
            value={value}
          />
        )}
        rules={{ required: "Data source type is required" }}
      />
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Field>
  );
};

export default ControlledRadioButtonGroup;
